function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.614,15.7c0-.39.1-.875.1-1.267A12.55,12.55,0,0,0,32.034,1.945,12.307,12.307,0,0,0,21.794,7.017a9.076,9.076,0,0,0-5.072-1.463,9.553,9.553,0,0,0-9.555,9.464v.78A9.457,9.457,0,0,0,1.7,24.375,10.562,10.562,0,0,0,12.627,34.81H39.543A10.562,10.562,0,0,0,50.47,24.375,9.251,9.251,0,0,0,44.614,15.7Z",
  transform: "translate(-1.7 -1.848)",
  fill: "#1590cf"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3,36.688l1.028,2.441-2.312,4.046,2.537,2.537,4.176-1.96L31.17,44.78,32.447,48.6l.129.449h3.6l1.509-4.27,2.441-1.028,3.6,1.859.449.225L46.708,43.3l-1.927-3.976,1.028-2.441L49.63,35.6l.449-.129v-3.6l-4.265-1.509-1.028-2.44,1.859-3.6.225-.449L44.431,21.34,40.385,23.3,37.944,22.27,36.66,18.449,36.433,18H32.994l-1.509,4.27L29.045,23.3l-3.6-1.859L25,21.214,22.594,24.1,24.328,27.8,23.3,30.237l-3.821,1.284-.449.225v3.432Zm6.294-3.114a4.978,4.978,0,1,1,4.977,4.976,4.921,4.921,0,0,1-4.977-4.976Z",
  transform: "translate(-0.08 -0.346)",
  fill: "#046eab"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.026,44.014l.949,1.016-.406,2.413,1.71.79,1.7-1.722,1.389.063,1.325,1.649.145.2,1.771-.656-.032-2.377,1.016-.949,2.11.265.261.03.79-1.709-1.671-1.613.063-1.389L21.8,38.7l.2-.145-.656-1.771-2.377.032L18.015,35.8l.266-2.109.028-.262-1.662-.807-1.64,1.7-1.389-.063L12.293,32.6l-.192-.182-1.693.623.032,2.378-1.016.948-2.1-.256-.261-.03-.663,1.859,1.524,1.5-.062,1.385L6.205,42.161l-.18.192.623,1.693Zm2.536-2.676a2.613,2.613,0,1,1,3.355,1.549,2.584,2.584,0,0,1-3.355-1.549Z",
  transform: "translate(-1.296 1.001)",
  fill: "#59b4d9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.531,29.162c0-4,2.048-7.119,5.851-9.069v-.78a10.234,10.234,0,0,1,15.506-8.582A13.484,13.484,0,0,1,40.811,5.171a13.21,13.21,0,0,0-8.777-3.315A12.655,12.655,0,0,0,21.794,7.025a9.076,9.076,0,0,0-5.072-1.463,9.553,9.553,0,0,0-9.555,9.464v.78A9.457,9.457,0,0,0,1.7,24.383,10.341,10.341,0,0,0,9.9,34.525a10.949,10.949,0,0,1-1.37-5.364Z",
  transform: "translate(-1.7 -1.856)",
  fill: "#59b4d9"
});

var SvgAppConfiguration = function SvgAppConfiguration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49.423,
    viewBox: "0 0 50 49.423",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppConfiguration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/app_configuration.2eae00d6.svg";
export { ForwardRef as ReactComponent };